module.exports = __webpack_public_path__ + "img/9788996575597.8b1f9420.jpg";